module.exports = __webpack_public_path__ + "static/media/indices.28607de6.jpg";